import { mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import TabsComponent from '@/agilis/components/Tabs/Tabs.vue'

export default {
  name: 'TrackerTabs',

  data: () => ({
  }),

  components: {
    TabsComponent
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      authorizedAppTrackerTypes: 'contextStore/trackerTypes',
      pushMessagesShow: 'notificationStore/pushMessagesShow'
    }),

    applicationDataTableOverride () {
      const app = Configuration.getApplication(this.applicationId)
      return app.dataTableComponentId
    },

    tabs () {
      return Object.keys(this.authorizedAppTrackerTypes)
    },

    showPushMessages () {
      return this.pushMessagesShow
    }
  },

  methods: {
    overrideComponentId (trackerTypeId) {
      return this.authorizedAppTrackerTypes[trackerTypeId].dataTableComponentId || this.applicationDataTableOverride
    },

    trackerTitle (trackerTypeId) {
      return this.$t(this.authorizedAppTrackerTypes[trackerTypeId].name)
    },

    trackerDescription (trackerTypeId) {
      return this.$t(this.authorizedAppTrackerTypes[trackerTypeId].description)
    },

    trackerApi (trackerTypeId) {
      return this.$axios.agilisUrlTracker(this.applicationId, trackerTypeId)
    },

    trackerDatatableConfiguration (trackerTypeId) {
      return Configuration.datatable.getDatatable({
        applicationId: this.applicationId,
        trackerTypeId: trackerTypeId,
        workspaceId: this.workspaceId
      })
    },

    componentResolverProps (trackerTypeId) {
      return {
        viewComponentId: 'TrackerDataTableView',
        configuration: this.trackerDatatableConfiguration(trackerTypeId),
        propTitle: this.trackerTitle(trackerTypeId),
        description: this.trackerDescription(trackerTypeId),
        api: this.trackerApi(trackerTypeId)
      }
    }
  }
}
